import { useEffect, useState } from "react";
import {
  fetchMembershipsCatalog,
  MembershipsCatalog,
} from "../api/contentful";

export function useMembershipsCatalog() {
  const [data, setData] = useState<MembershipsCatalog | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchMembershipsCatalog()
      .then((res) => setData(res))
      .catch((err) =>
        setError(err.message || "Failed to load memberships"),
      )
      .finally(() => setLoading(false));
  }, []);

  return { data, loading, error };
}
